import { render, staticRenderFns } from "./jpdkDetail.vue?vue&type=template&id=ed2367a2"
import script from "./jpdkDetail.vue?vue&type=script&lang=js"
export * from "./jpdkDetail.vue?vue&type=script&lang=js"
import style0 from "./jpdkDetail.vue?vue&type=style&index=0&id=ed2367a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports